import React from 'react';
import { IconOpenLinkBold, Text } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

interface Props {
  className?: string;
  shopDepartment: string;
  onClick: () => void;
}

export const MetaStylePdpLink: React.FC<React.PropsWithChildren<Props>> = ({ className, shopDepartment, onClick }) => {
  return (
    <Container className={className}>
      <LinkButton onClick={onClick}>
        <Text as='p' variant='Body_13_Multiline_Regular' color='textSecondary'>
          {shopDepartment}에서 정보를 확인하고 싶나요?
        </Text>
        <TextButton variant='Body_13_Multiline_SemiBold' color='textPrimary'>
          {shopDepartment} 가기
          <IconOpenLinkBold size={20} />
        </TextButton>
      </LinkButton>
    </Container>
  );
};

const Container = styled.div`
  padding: 0 16px;
`;

const LinkButton = styled.div`
  padding: 14px 12px 14px 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-radius: 6px;
  cursor: pointer;
  background-color: ${vars.color.backgroundBase};
`;

const TextButton = styled(Text)`
  display: flex;
  align-items: center;
  gap: 2px;
  white-space: nowrap;
`;
